// extracted by mini-css-extract-plugin
module.exports = {"row":"PrimaryLinks-style__row__e1bd129f","item":"PrimaryLinks-style__item__e1bd129f","link":"PrimaryLinks-style__link__e1bd129f"};